import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";
import { fetchCandidate } from "./Actions";
import { CandidateId } from "./PropTypes";

const candidateId = (_: StoreState, entityId: CandidateId) => entityId;
const fetchCandidates = ({candidates}: StoreState) => candidates;
export const getCandidates = createSelector(fetchCandidates, (candidates) => (candidates));
export const getCandidateValuesFromCandidateId = createSelector(fetchCandidates, candidateId, (candidates, candidateId) => (candidates.valuesByEntityIdByFieldId?.[candidateId]));
export const getCandidate = createSelector([fetchCandidates, candidateId], (candidates, candidateId) => (candidates.entities?.[candidateId]));

const getAllCandidatesFromState = ({ candidates }: any): any[] => candidates?.saved;
export const getAllCandidates = createSelector(getAllCandidatesFromState, (getAllCandidatesFromState) => getAllCandidatesFromState);

const getAllCandidatesMetaFromState = ({ candidates }: any): any[] => candidates?.meta;
export const getAllCandidatesMeta = createSelector(getAllCandidatesMetaFromState, (getAllCandidatesMetaFromState) => getAllCandidatesMetaFromState);

const getCandidateValuesByIdFromState = ({ candidates }: any, candidateId: any): any => {
    const candidateKeys = Object.keys(candidates?.unsaved);

    let saved = candidates?.saved[candidateId];
    if (candidateKeys.length == 0) return {...saved};

    let newValues: any = [];

    for (let key of Object.keys(candidates?.unsaved[candidateId])) {
        let item = candidates?.unsaved[candidateId][key];

        if (item.id) continue; 

        newValues.push({
            id: item.id,
            field_id: key,
            entity_id: candidateId,
            value: item.value
        });
    }

    let adjustedValues = saved?.values.map((value: any) => {
        if (!candidates?.unsaved[candidateId]) return value;
        if (!candidates?.unsaved[candidateId][value.field_id]) return value;

        return {
            ...value,
            value: candidates.unsaved[candidateId][value.field_id]['value']
        }
    });

    return {
        ...saved,
        values: [...newValues, ...adjustedValues]
    };
};
export const getCandidateValuesById = createSelector(getCandidateValuesByIdFromState, (getCandidateValuesByIdFromState) => getCandidateValuesByIdFromState);

const getCandidateUnsavedChangesByIdFromState = ({ candidates }: any, candidateId: any): any[] => candidates?.unsaved[candidateId];
export const getCandidateUnsavedChangesById = createSelector(getCandidateUnsavedChangesByIdFromState, (getCandidateUnsavedChangesByIdFromState) => getCandidateUnsavedChangesByIdFromState);

const getCandidateEntityByIdFromState = ({ candidates }: any, candidateId: any): any[] => candidates?.saved[candidateId]?.entity[0];
export const getCandidateEntityById = createSelector(getCandidateEntityByIdFromState, (getCandidateEntityByIdFromState) => getCandidateEntityByIdFromState);

const getAllCandidateStatussesByIdFromState = ({ candidates }: any, candidateId: any): any[] => candidates?.saved[candidateId]?.status;
export const getAllCandidateStatussesById = createSelector(getAllCandidateStatussesByIdFromState, (getAllCandidateStatussesByIdFromState) => getAllCandidateStatussesByIdFromState);

const getDataset = ({candidates}: any) => candidates.datasets;
export const getCandidateDataset = createSelector(getDataset, ({entities}) => entities); 
export const getCandidateDatasetKeys = createSelector(getDataset, ({ids}) => ids);

const getNewCandidateIdFromState = ({ candidates }: any): any[] => candidates?.new;
export const getNewCandidateId = createSelector(getNewCandidateIdFromState, (getNewCandidateIdFromState) => getNewCandidateIdFromState);




const fetchRecords = ({ candidates }: StoreState) => candidates;
const byId = (_: StoreState, id) => id

export const getCandidateById = createSelector(
    fetchRecords,
    byId,
    ({ entities }, id) => entities?.[id]
);

export const getCandidateByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
)

export const getCandidateCreateFlowId = createSelector(
    fetchRecords,
    ({ createFlowId }) => createFlowId
)

export const isCandidateFetching = createSelector(
    fetchRecords,
    ({ _isFetching }) => _isFetching
);

export const isCandidateDatasetFetching = createSelector(
    fetchRecords,
    ({ datasets: { _isFetching } }) => _isFetching
)

export const getCandidateValuesByIdV2AsObject = createSelector(
    fetchRecords,
    ({ valuesByEntityIdByFieldId }) => valuesByEntityIdByFieldId
)

export const getCandidateValuesByIdV2 = createSelector(
    fetchRecords,
    (_, record_id) => record_id,
    ({ valuesByEntityIdByFieldId }, record_id) => valuesByEntityIdByFieldId?.[record_id]
)